import { render, staticRenderFns } from "./UserAppGrid.vue?vue&type=template&id=2cd07240"
import script from "./UserAppGrid.vue?vue&type=script&lang=js"
export * from "./UserAppGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports